(function (angular) {
    angular
        .module('one.admin')
        .controller('TransactionalMailFailuresModalController', TransactionalMailFailuresModalController);

    TransactionalMailFailuresModalController.$inject = ['$scope', '$filter', '$uibModalInstance', '$state', 'dataframe', 'session', 'TransactionalMailService', 'params'];

    function TransactionalMailFailuresModalController($scope, $filter, $uibModalInstance, $state, dataframe, session, TransactionalMailService, params) {
        angular.extend($scope, params);

        $scope.failures = dataframe.init({
            externalData: function (params) {
                return TransactionalMailService.failures($scope.transactionalMail.id, params);
            },
            cols: [
                {
                    name: 'title',
                    title: 'Name',
                    display: function (row) {
                        var icon = 'person';

                        if (row.account.account_type_name == 'organisation') {
                            icon = 'business';
                        };

                        return '<i class="md-icon">' + icon + '</i> <strong>{{ row.account.title }}</strong>';
                    },
                    weight: 1
                },
                {
                    name: 'email',
                    title: 'E-mail',
                    display: function (row) {
                        return row.recipient
                    },
                    weight: 1
                },
                {
                    name: 'status_reason',
                    title: 'Reason',
                    display: function (row) {
                        return '<span class="text-limiter">{{ row.status_reason }}</span>';
                    },
                    weight: 1
                },
                {
                    title: 'Timestamp',
                    name: 'created_at',
                    weight: 1,
                    display: function (row) {
                        return $filter('formatDate')(row.created_at, 'short');
                    },
                    sortable: true
                }
            ],
            perPage: 5,
            rowClick: function (row) {
                $uibModalInstance.close();

                $state.transitionTo('crm.accounts.account.index', {accountId: row.account.id});
            },
            state: session.get('data.dataframes.sent_mail_per_status', {
                sort: {
                    created_at: 'desc'
                }
            })
        });

        $scope.close = $uibModalInstance.close;
    }
})(angular);
